export const CONCEPT_TRANSLATION_MAP = {
  DEPOSIT: 'controlpanel.purse.table.column.concept.deposit',
  WITHDRAWAL: 'controlpanel.purse.table.column.concept.withdrawal'
};
